import { jsx as _jsx } from "react/jsx-runtime";
/** The single way sections read dynamic data: a React context carrying the RenderContext. */
import { createContext, useContext } from 'react';
const Ctx = createContext(null);
export function RenderProvider({ value, children }) {
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useRenderContext() {
    const v = useContext(Ctx);
    if (!v) {
        throw new Error('useRenderContext() must be used inside a <PageRenderer> (RenderProvider) subtree.');
    }
    return v;
}
/**
 * Like {@link useRenderContext} but returns `null` instead of throwing when there's no provider above.
 * For shared leaf components (e.g. the Material Symbols font loader) that read an OPTIONAL context hint
 * yet must still render standalone — in a Storybook story or a unit test — without a PageRenderer.
 */
export function useRenderContextOptional() {
    return useContext(Ctx);
}
//# sourceMappingURL=RenderProvider.js.map